<!-- header -->
<app-header></app-header>

<!-- routes will be rendered here -->
<router-outlet>
    <!-- <ngx-loading [show]="isBusy" [config]="{primaryColour: '#ffffff', secondaryColour: '#ccc', tertiaryColour: '#ffffff', backdropBorderRadius: '3px'}"></ngx-loading> -->
	<ngx-spinner bdColor="rgba(0,0,0,0.3)" size="medium" color ="#fff" type="ball-spin-fade" [fullScreen] = "true"></ngx-spinner>	
</router-outlet>

<!-- footer -->
<app-footer></app-footer>